import { render, staticRenderFns } from "./ETaxAndVrtModal.vue?vue&type=template&id=3bf3c5b7&scoped=true"
import script from "./ETaxAndVrtModal.vue?vue&type=script&lang=js"
export * from "./ETaxAndVrtModal.vue?vue&type=script&lang=js"
import style0 from "./ETaxAndVrtModal.vue?vue&type=style&index=0&id=3bf3c5b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf3c5b7",
  null
  
)

export default component.exports